import Model from "./Modal.svelte";
import { renderComponent } from "$lib/utils/renderComponent";
import type { ModalProps } from "./types";
import { generateObjectKey } from "$lib/utils/tools";

export default Model;
const keys = [];

/**
 * 显示弹窗
 * @param options 模态框配置选项
 */
export function showModal(options: ModalProps) {
  const key = generateObjectKey(options);
  if (keys.includes(key)) {
    return;
  }
  keys.push(key);

  const { onConfirm, onClose, onCancel, show } = options || {};

  const { destroyWithRemove } = renderComponent(Model, {
    ...options,
    show: show || true,
    onConfirm: () => {
      handleClose();
      onConfirm?.();
    },
    onClose: () => {
      handleClose();
      onClose?.();
    },
    onCancel: () => {
      handleClose();
      onCancel?.();
    },
  });

  function handleClose() {
    keys.splice(keys.indexOf(key), 1);
    destroyWithRemove();
    options?.onClose?.();
  }

  return options;
}
